import React from "react";
import { connect } from "react-redux";
import { compose, lifecycle } from "recompose";
import { withRouter, Route } from "react-router-dom";

import { Card, CardText } from "react-md";

import UserOrganization from "./UserOrganization";
import Header from "../components/organizations/Header";
import Filter from "../components/organizations/Filter";
import Table from "../components/organizations/Table";
import OauthApplications from "../components/organizations/OauthApplications";
import OrganizationFoundForm from "../components/organizationFound/Form";
import OrganizationAddExistingForm from "../components/organizationAddExisting/Form";

import { getUserOrganizations, canUserEditThisOrganization_init_mustRunAfterOrganizationsAreDownloaded } from "../actions/resourceActions";

import {DebugElement, DebugRoute} from "../Atollon/debug";
import {TouchPageHeader_and_content_spaceBetween} from "../AtollonTheme/ReactElements";

let isOnInstanceListPage = ( match, location ) =>
{
    return match.url === location.pathname;
};

const UserOrganizations = ({ match, history, location, activeForm }) => {

  let isOnList = isOnInstanceListPage( match, location );
  if( isOnList )
  {
    return (
      <div className="flex-col">

        <DebugElement text={"src/container/UserOrganization.js [match.url = location.pathname]"}/>

        <Header />

        <TouchPageHeader_and_content_spaceBetween heightPx={50}/>
        {activeForm === "organizationFoundForm" && (
          <Card className="margin-bottom">
            <CardText>
              <OrganizationFoundForm userOrganization />
            </CardText>
          </Card>
        )}
        {activeForm === "organizationAddExistingForm" && (
              <Card className="margin-bottom">
                  <CardText>
                      <OrganizationAddExistingForm userOrganization />
                  </CardText>
              </Card>
        )}

        <Filter />

        <div style={{height: '25px'}} />

        <DebugElement text="/containers/UserOrganization.js - /components/organizations/Table" />

        <Table history={history} />

        <div style={{height: '30px'}} />

        <OauthApplications />
      </div>
    );
  }
  else
  {
      return (
        <DebugRoute
          path={`${match.url}/:id`}
          render={() => <UserOrganization history={history} />}
        />
      );

  }
};

export default compose(
  withRouter,
  connect(({ app: { form: { activeForm } }, resource: { myAtollon_selectedUserOrganizationTypeName } }) => ({ activeForm, myAtollon_selectedUserOrganizationTypeName }), {
    getUserOrganizations,
    canUserEditThisOrganization_init_mustRunAfterOrganizationsAreDownloaded
  }),
  lifecycle({
    async componentWillMount() {
      const { getUserOrganizations, canUserEditThisOrganization_init_mustRunAfterOrganizationsAreDownloaded, match, location, myAtollon_selectedUserOrganizationTypeName } = this.props;

      let isOnList = isOnInstanceListPage( match, location );
      if( isOnList )
      {

          // Do not reset change if user selected it once ... easier to check of it here
          let chooseRelatedAsDefault_ButOnlyForTheFirstTime;
          if( ! myAtollon_selectedUserOrganizationTypeName )
          {
              chooseRelatedAsDefault_ButOnlyForTheFirstTime = true;
          }
          else
          {
              chooseRelatedAsDefault_ButOnlyForTheFirstTime = false;
          }

          await getUserOrganizations("related",chooseRelatedAsDefault_ButOnlyForTheFirstTime);
        await canUserEditThisOrganization_init_mustRunAfterOrganizationsAreDownloaded();
      }
      else
      {
      }
    }
  })
)(UserOrganizations);



// WEBPACK FOOTER //
// ./src/pages/UserOrganizations.js